var _export = require('./export.js');
var transformPurchase = require('./transform.js');
var usePromoService = require('../purchase/promotions.js');
var _require = require('../purchase'),
  restorePurchaseService = _require.restorePurchaseService;
var restoreCalc = function restoreCalc(basket, _ref) {
  var gpiConfig = _ref.gpiConfig,
    pointsConfig = _ref.pointsConfig;
  purchaseService = restorePurchaseService({
    basket: basket,
    fee_buster_config: gpiConfig.fee_buster_config,
    points_config: pointsConfig,
    price_increase: gpiConfig.price_increase
  });
  var items = {};
  purchaseService.purchases.forEach(function (p) {
    items[p.uuid] = transformPurchase(purchaseService, p, gpiConfig.price_increase.excludedDepts);
  });
  var promoService = usePromoService(purchaseService);
  var savingsMap = promoService.getBuyMoreAndSaveList();
  items = promoService.addBuyMoreAndSave(items, savingsMap);
  return _export(items, purchaseService, {
    basket_data: true,
    delivery_amount: null,
    points_config_enabled: pointsConfig === null || pointsConfig === void 0 ? void 0 : pointsConfig.enabled
  });
}; // restoreCalc

module.exports = restoreCalc;